import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: []
    },
    lastName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
      ]
    },
    StartTime: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    theme: {
      validations: []
    },
    SiteName: {
      validations: []
    },
    Notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Last Name:',
           mapping: 'lastName'
         }
       ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:',
            mapping: 'email'
          },
         ]
        },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Phone:',
           mapping: 'telnumber'
         }
       ]
     },
        {
          fields: [
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'Event Date:',
              mapping: 'eventDate'
            }
          ]
        },
        {
          fields: [
            {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'Event Start Time:',
              options: [
                { label: '7:30 AM', value: '07:30:00' },
                { label: '8:00 AM', value: '08:00:00' },
                { label: '8:30 AM', value: '08:30:00' },
                { label: '9:00 AM', value: '09:00:00' },
                { label: '9:30 AM', value: '09:30:00' },
                { label: '10:00 AM', value: '10:00:00' },
                { label: '10:30 AM', value: '10:30:00' },
                { label: '11:00 AM', value: '11:00:00' },
                { label: '11:30 AM', value: '11:30:00' },
                { label: '12:00 PM', value: '12:00:00' },
                { label: '12:30 PM', value: '12:30:00' },
                { label: '1:00 PM', value: '13:00:00' },
                { label: '1:30 PM', value: '13:30:00' },
                { label: '2:00 PM', value: '14:00:00' },
                { label: '2:30 PM', value: '14:30:00' },
                { label: '3:00 PM', value: '15:00:00' },
                { label: '3:30 PM', value: '15:30:00' },
                { label: '4:00 PM', value: '16:00:00' },
                { label: '4:30 PM', value: '16:30:00' },
                { label: '5:00 PM', value: '17:00:00' },
                { label: '5:30 PM', value: '17:30:00' },
                { label: '6:00 PM', value: '18:00:00' },
                { label: '6:30 PM', value: '18:30:00' },
                { label: '7:00 PM', value: '19:00:00' },
                { label: '7:30 PM', value: '19:30:00' },
                { label: '8:00 PM', value: '20:00:00' },
                { label: '8:30 PM', value: '20:30:00' },
                { label: '9:00 PM', value: '21:00:00' },
                { label: '9:30 PM', value: '21:30:00' },
                { label: '10:00 PM', value: '22:00:00' },
                { label: '10:30 PM', value: '22:30:00' },
                { label: '11:00 PM', value: '23:00:00' },
                { label: '11:30 PM', value: '23:30:00' },
              ],
              mapping: 'StartTime'
            }
          ]
        },
        {
          fields: [
            {
               type: 'text',
               size: 'Medium',
               label: 'Estimated Guest Count:',
               mapping: 'plannedguestcount'
             }
           ]
         },
         {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Event Type:',
              mapping: 'theme'
            }
          ]
        },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Event Location:',
                options: [
                  { label: '28 Event Space', value: '28 Event Space' },
                  { label: 'The Moose Truck', value: 'The Moose Truck' },
                  { label: 'The View at Briarcliff', value: 'The View at Briarcliff' },
                  { label: 'HyVee Arena', value: 'HyVee Arena' },
                  { label: 'The Gatsby on Oak', value: 'The Gatsby on Oak' },
                  { label: 'Other/Off-premise', value: 'Other/Off-premise' },
                ],
                mapping: 'SiteName'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text-area',
                size: 'Medium',
                label: 'Any Additional Details About Your Event?:',
                mapping: 'Notes'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'KC Hopps Catering & Events Contact Form',
    formId: '786',
    clientKey: '1599D1F7-1F86-404B-90FE-58C18A1DFE0F',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
